import type { ConversationKind } from '@rp/contracts'
import { Button, Dialog } from '../../design'
import { REPLY_COPY } from './copy'

export const SendConfirmSheet = ({
  open,
  kind,
  destination,
  text,
  pending,
  onCancel,
  onConfirm,
}: {
  open: boolean
  kind: ConversationKind
  destination: string
  text: string
  pending: boolean
  onCancel: () => void
  onConfirm: () => void
}) => (
  <Dialog
    open={open}
    title={REPLY_COPY.confirmTitle[kind]}
    onClose={onCancel}
    className="confirm-sheet"
    tone="danger"
    edge="hatch"
    footer={
      <>
        <Button onClick={onCancel}>{REPLY_COPY.confirmCancel}</Button>
        <Button
          className="confirm-send"
          variant="irreversible"
          size="large"
          pending={pending}
          pendingLabel={REPLY_COPY.sending}
          onClick={onConfirm}
        >
          {REPLY_COPY.confirmSend}
        </Button>
      </>
    }
  >
    <p className="confirm-warning">{REPLY_COPY.confirmWarning[kind]}</p>
    <div className="confirm-restate">
      <p className="confirm-destination">{destination}</p>
      <p className="confirm-text">{text}</p>
    </div>
    <p className="confirm-note num">{REPLY_COPY.confirmNote}</p>
  </Dialog>
)
